import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./translations.html";
import { getUniqueObject } from '../utils/util';
import { VALIDATION_NOT_REQUIRED } from '../utils/appConstants';
const columns = [{
  label: 'Language',
  fieldName: 'name',
  sortable: true,
  initialWidth: 300
}, {
  label: 'Count',
  fieldName: 'languageCount',
  sortable: true
}];
class Translations extends LightningElement {
  constructor(...args) {
    super(...args);
    this.data = [];
    this.isexportbtndisabled = void 0;
    this.preselectedrowsids = void 0;
    this.columns = columns;
    this.currentSelectedRows = [];
    this.filterSelRows = [];
    this.isTranslationsSelectedToExport = false;
    this.getSelectedTranslation = event => {
      let formatSelectedRows = [];
      let currentRows = event.detail.selectedRows;
      if (this.currentSelectedRows.length > 0) {
        let selectedIds = currentRows.map(row => row.id);
        let unselectedRows = this.currentSelectedRows.filter(row => !selectedIds.includes(row.id));
        console.log(unselectedRows);
      }
      this.currentSelectedRows = currentRows;
      for (let index = 0; index < this.currentSelectedRows.length; index++) {
        const {
          id,
          name,
          languageCount,
          modifiedBy,
          modifiedOn,
          translationConfigurations
        } = this.currentSelectedRows[index];
        const formatName = `${name} (${languageCount})`;
        const formattedRows = {
          id,
          languageCount,
          modifiedBy,
          modifiedOn,
          name: formatName,
          translationConfigurations,
          message: VALIDATION_NOT_REQUIRED,
          isError: true,
          isTranslation: true
        };
        formatSelectedRows.push(formattedRows);
      }
      this.filterSelRows = getUniqueObject(formatSelectedRows);
      const detailObject = {
        'translationRows': this.filterSelRows,
        'isTranslation': true
      };
      const selectedEvent = new CustomEvent('selectedsourcegridrows', {
        detail: detailObject,
        bubbles: true,
        composed: true
      });
      this.dispatchEvent(selectedEvent);
    };
    this.closeExportConfModal = () => {
      this.isTranslationsSelectedToExport = false;
    };
    this.updateSelectedTranslations = () => {
      this.currentSelectedRows = [];
    };
    this.handleExportTranslations = () => {
      let selectedRowsData = this.currentSelectedRows;
      let formattedTranslationsConfig = [];
      for (let index = 0; index < selectedRowsData.length; index++) {
        const {
          translationConfigurations
        } = selectedRowsData[index];
        formattedTranslationsConfig.push(this.formatTranslations(translationConfigurations));
      }
      const detailObject = {
        'selectedTranslationRows': formattedTranslationsConfig.flat(),
        'isTranslation': true
      };
      const exportConfigurationRows = new CustomEvent('exportconfigurations', {
        detail: detailObject,
        bubbles: true,
        composed: true
      });
      this.dispatchEvent(exportConfigurationRows);
    };
    this.formatTranslations = selTranslations => {
      let tempTranslations = [];
      if (selTranslations.length > 0) {
        for (let index = 0; index < selTranslations.length; index++) {
          const {
            componentType,
            configType,
            componentName,
            createdBy,
            createdOn,
            developerName,
            id,
            modifiedBy,
            modifiedOn,
            name,
            translationConfigurations
          } = selTranslations[index];
          const formattedRow = {
            componentType,
            configType,
            componentName,
            createdBy,
            createdOn,
            developerName,
            id,
            modifiedBy,
            modifiedOn,
            name,
            translationConfigurations
          };
          tempTranslations.push(formattedRow);
        }
      }
      return tempTranslations;
    };
  }
}
_registerDecorators(Translations, {
  publicProps: {
    data: {
      config: 0
    },
    isexportbtndisabled: {
      config: 0
    },
    preselectedrowsids: {
      config: 0
    },
    updateSelectedTranslations: {
      config: 0
    }
  },
  fields: ["columns", "currentSelectedRows", "filterSelRows", "isTranslationsSelectedToExport", "getSelectedTranslation", "closeExportConfModal", "handleExportTranslations", "formatTranslations"]
});
export default _registerComponent(Translations, {
  tmpl: _tmpl
});